'use strict';

var disassembleISODatePartToParts = require('../disassembleToParts/disassembleISODatePartToParts.cjs');

const compareISODatePart = (l, r) => {
  const lParts = disassembleISODatePartToParts(l);
  const rParts = disassembleISODatePartToParts(r);
  if (lParts.year !== rParts.year) {
    return lParts.year - rParts.year;
  }
  if (lParts.month !== rParts.month) {
    return lParts.month - rParts.month;
  }
  return lParts.day - rParts.day;
};

exports.compareISODatePart = compareISODatePart;
//# sourceMappingURL=compareISODatePart.cjs.map
